import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../context/UserContext";

// Only admin/super_admin may reach booking/room admin pages. Kitchen staff
// (chefs) log in through the same ChopNation auth as customers, but their
// dashboard is the Kitchen Dashboard only; everyone else falls back home.
const ADMIN_ROLES = ["admin", "super_admin"];

const AdminGate = () => {
  const { user } = useUser();

  if (user?.role === "kitchen_staff") {
    return <Navigate to="/kitchen/dashboard" replace />;
  }

  if (!ADMIN_ROLES.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminGate;
